import { lazy } from "react";
import { IRoute } from "./types";

const NotFound = lazy(() => import("pages/exceptions/NotFound"));
const Staffs = lazy(() => import("pages/dashboard/user/staff"));
const Organizations = lazy(() => import("pages/dashboard/user/organization"));
const MachineLock = lazy(() => import("pages/dashboard/settings/machine_lock"));
const Permissions = lazy(() => import("pages/dashboard/rbac/permission"));
const Groups = lazy(() => import("pages/dashboard/rbac/group"));
const Roles = lazy(() => import("pages/dashboard/rbac/role"));

const PaymentTypes = lazy(
  () => import("pages/dashboard/settings/payment_type")
);
const PaymentConfig = lazy(
  () => import("pages/dashboard/settings/payment_config")
);

const dashboardRoutes: IRoute[] = [
  {
    key: "/settings/payment_type",
    path: "settings/payment_type",
    component: <PaymentTypes />,
  },
  {
    key: "/settings/payment_config",
    path: "settings/payment_config",
    component: <PaymentConfig />,
  },
  {
    key: "/user/staff",
    path: "user/staff",
    component: <Staffs />,
  },
  {
    key: "/user/organization",
    path: "user/organization",
    component: <Organizations />,
  },
  {
    key: "/dashboard/settings/machine_lock",
    path: "/dashboard/settings/machine_lock",
    component: <MachineLock />,
  },

  {
    key: "/dashboard/rbac/permission",
    path: "/dashboard/rbac/permission",
    component: <Permissions />,
  },
  {
    key: "/dashboard/rbac/group",
    path: "/dashboard/rbac/group",
    component: <Groups />,
  },
  {
    key: "/dashboard/rbac/role",
    path: "/dashboard/rbac/role",
    component: <Roles />,
  },

  {
    key: "not_found",
    path: "*",
    component: <NotFound />,
  },
];
export default dashboardRoutes;
